import { Component } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'

declare const gtag: Function

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  
  constructor(public router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-RZVQQ608YJ', { 'page_path': event.urlAfterRedirects })
      }
    })
  }

}
